
























import { DataParse } from "@wj/common";
import { Vue, Component } from "vue-property-decorator";
import { listReq } from "@/common/class/h5/index";
import { login } from "@/api/h5/index";
import { Cell, Toast, Icon, Form, Field, Button, Loading } from "vant";

@Component({
  components: {
    [Cell.name]: Cell,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
  },
})
export default class empowermentQueryComponent extends Vue {
  noAccount = true;
  loading = false;
  loginReq = {
    account: "",
    password: "",
  };
  created() {
    localStorage.setItem('token', "");
    if (this.$route.query.flag == "registerComplete") {
      this.noAccount = false;
    }
  }

  mounted() {}
  goRegister() {
    this.$router.push("pages/register");
  }
  forgetPassWord() {
    this.$router.push("pages/forgetPassWord");
  }
  goBack() {
    this.$router.push("/pages/home");
  }
  onSubmit() {
    this.loading = true;
    login(this.loginReq)
      .then((res) => {
        const { data, success, message } = res;
        if (success) {
          Toast.success("登录成功！");
          localStorage.setItem("token", data);
          this.$router.push("pages/home");
        }else{
           Toast.success("登录失败！");
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
  onFailed(errorInfo: any) {
    if (errorInfo.errors.length > 0) {
      Toast("请填写完整星号内容！");
    }
  }
}
